var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeaturePayRate = function SvgFeaturePayRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "m20.3 4.7-.3-.1c-2.6-.5-5.3-.5-7.9.2l-.5.1c-2.4.6-4.9.7-7.3.2-.5-.1-1 0-1.5.4-.3.3-.6.8-.6 1.3v10.8c0 .8.6 1.6 1.4 1.7h.2c1.2.2 2.5.4 3.7.4 1.6 0 3.1-.2 4.6-.6l.2-.1c2.4-.6 4.9-.6 7.2-.2.5.1 1 0 1.5-.4.4-.3.6-.8.6-1.4V6.4c.2-.8-.4-1.6-1.3-1.7m-.1 12.5c0 .1-.1.2-.1.2s-.1.1-.2.1c-2.6-.5-5.3-.5-7.9.2l-.2.1c-2.5.6-5.2.7-7.7.2h-.2c-.1 0-.2-.1-.2-.2v-11c0-.1.1-.2.1-.2s.1-.1.2-.1h.1c2.5.6 5.3.5 7.8-.1l.5-.1c2.4-.6 4.9-.6 7.2-.2h.4c.1 0 .2.1.2.2v10.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.5 8a.75.75 0 0 1 .75.75v.875a.75.75 0 0 1-1.5 0V8.75A.75.75 0 0 1 11.5 8M11.5 14.125a.75.75 0 0 1 .75.75v.875a.75.75 0 0 1-1.5 0v-.875a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M10.978 10.374a.478.478 0 0 0-.115.944l1.64.412a1.978 1.978 0 0 1-.482 3.898h-.958c-.763 0-1.377-.425-1.72-.986a.75.75 0 0 1 1.279-.783c.11.18.27.269.441.269h.959a.478.478 0 0 0 .115-.944l-1.64-.412a1.978 1.978 0 0 1 .48-3.898h.96c.762 0 1.375.421 1.72.983a.75.75 0 1 1-1.28.784.512.512 0 0 0-.44-.267z",
    clipRule: "evenodd"
  })));
};
export default SvgFeaturePayRate;